export default {"src":"/_next/static/image/public/images/ic_info_green.ef8e01c91404f9706dfc709989a199de.svg","height":20,"width":20};